import React, { FocusEventHandler, FormEventHandler } from 'react';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { Heading } from '@mos-cat/typography';
import { Trans } from '@lingui/macro';
import {
  getPayload,
  setErrorToSecondParentRelativeFields,
  trimOnBlur
} from '../../../helpers/handlers';
import { SecondParent } from './SecondParent';
import TextField from '../../shared/TextField/TextField';
import { SECOND_PARENT_FIELD_NAME } from '../../../constants/fieldNames';
import { Field } from '../../../declarations/widget-ums';
import { secondParentDivorcedSelector } from '../../../models/children';
import { getPersonPlaceholder } from '../../../helpers/getPlacelholder';
import {
  isDateInvalid,
  maxAcceptableDate,
  minAcceptableDate,
  getDateBeforeThis,
  getDateAfterThis
} from '../../../helpers/dateHelpers';

import { getErrorLocation } from '../../../helpers/errorLocation';
import { ERROR_DATE } from '../../../constants/errors';
import DateField from '../../shared/DateField/DateField';
import { CHILD } from '../../../models/child';

interface Props {
  dateOfMarriage: Field<string>;
  dateOfDivorce: Field<string>;
  divorceDocIssuer: Field<string>;
  showTitle: boolean;
  onChange: FormEventHandler;
  onBlur: FocusEventHandler;
  trimOnBlur: FocusEventHandler;
}

function SecondParentDivorced({
  onChange,
  onBlur,
  trimOnBlur,
  dateOfMarriage,
  dateOfDivorce,
  divorceDocIssuer,
  showTitle
}: Props): JSX.Element {
  const { value: dateOfDivorceValue } = dateOfDivorce;
  const { value: dateOfMarriageValue } = dateOfMarriage;
  const dateOfMarriageMaxDate = isDateInvalid(dateOfDivorceValue)
    ? maxAcceptableDate
    : getDateBeforeThis(dateOfDivorceValue);
  const dateOfDivorceMinDate = isDateInvalid(dateOfMarriageValue)
    ? minAcceptableDate
    : getDateAfterThis(dateOfMarriageValue);

  return (
    <div className="StepContentBlock">
      {showTitle && (
        <Heading level={3} className="PguFormGrid__row">
          <Trans>Сведения о втором родителе ребёнка</Trans>
        </Heading>
      )}
      <SecondParent inMarriage={true} />
      <div className="PguFormGrid__row">
        <div className="PguFormGrid_col">
          <DateField
            errorLocation={getErrorLocation(
              dateOfMarriage,
              ERROR_DATE.DIVORCE_DATE_EARLY_MARRIAGE,
              ERROR_DATE.MARRIAGE_DATE_EARLY_APPLICANT_BIRTHDATE
            )}
            {...dateOfMarriage}
            placeholder={getPersonPlaceholder(
              SECOND_PARENT_FIELD_NAME.dateOfMarriage
            )}
            name={SECOND_PARENT_FIELD_NAME.dateOfMarriage}
            onChange={onChange}
            minDate={minAcceptableDate}
            maxDate={dateOfMarriageMaxDate}
            onBlur={onBlur}
          />
        </div>
        <div className="PguFormGrid_col">
          <DateField
            errorLocation={getErrorLocation(
              dateOfDivorce,
              ERROR_DATE.DIVORCE_DATE_EARLY_MARRIAGE
            )}
            {...dateOfDivorce}
            placeholder={getPersonPlaceholder(
              SECOND_PARENT_FIELD_NAME.dateOfDivorce
            )}
            name={SECOND_PARENT_FIELD_NAME.dateOfDivorce}
            onChange={onChange}
            minDate={dateOfDivorceMinDate}
            maxDate={maxAcceptableDate}
            onBlur={onBlur}
          />
        </div>
      </div>
      <div className="PguFormGrid__row">
        <TextField
          className="PguFormGrid_col"
          placeholder={getPersonPlaceholder(
            SECOND_PARENT_FIELD_NAME.divorceDocIssuer
          )}
          inputProps={{
            name: SECOND_PARENT_FIELD_NAME.divorceDocIssuer,
            ...divorceDocIssuer,
            onChange,
            onBlur: trimOnBlur,
            maxLength: 500
          }}
        />
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange(event) {
    const payload = getPayload(event);

    if (event.target.name === SECOND_PARENT_FIELD_NAME.dateOfDivorce) {
      setErrorToSecondParentRelativeFields(dispatch, CHILD, [
        SECOND_PARENT_FIELD_NAME.dateOfMarriage
      ]);
    }
    if (event.target.name === SECOND_PARENT_FIELD_NAME.dateOfMarriage) {
      setErrorToSecondParentRelativeFields(dispatch, CHILD, [
        SECOND_PARENT_FIELD_NAME.dateOfDivorce
      ]);
    }

    dispatch({
      type: 'child/secondParent/change',
      payload
    });
  },
  onBlur({ target: { name, value } }) {
    dispatch({
      type: `child/validate/field`,
      payload: { namespace: CHILD, name, value },
      additionalNamespace: 'secondParent'
    });
  },
  trimOnBlur: trimOnBlur('child/secondParent', dispatch)
});

const mapStateToProps = state => secondParentDivorcedSelector(state);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SecondParentDivorced);
